<h1 mat-dialog-title>
    <span [translate]="isCreation ? 'admin.entreprise.vehicules.energies.creation' : 'admin.entreprise.vehicules.energies.modification'"></span>
    <span [mat-dialog-close]="false"><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <form #form="ngForm">
        <fieldset>
            <div class="row">
                <custom-input ngDefaultControl
                              id="libelle"
                              name="libelle"
                              [(ngModel)]="data.energie.libelle"
                              customType="input"
                              libelle="admin.entreprise.vehicules.energies.libelle"
                              maxlength="2000"
                              required="true"></custom-input>
                <custom-input ngDefaultControl
                              id="ordre"
                              name="ordre"
                              [(ngModel)]="data.energie.ordre"
                              customType="number"
                              libelle="admin.entreprise.vehicules.energies.ordre"></custom-input>
            </div>
            <div class="row">
                <custom-input ngDefaultControl
                              id="code"
                              name="code"
                              [(ngModel)]="data.energie.code"
                              customType="input"
                              libelle="admin.entreprise.vehicules.energies.code"
                              maxlength="2000"></custom-input>
            </div>
        </fieldset>
    </form>
</div>
<div mat-dialog-actions *ngIf="!isLoading">
    <button mat-stroked-button color="warn" (click)="deleteEnergie()" [disabled]="isLoading" *ngIf="data.energie.idEnergie">
        <span *ngIf="!isLoading" [translate]="'global.actions.supprimer'"></span>
        <mat-spinner class="m-5" diameter="28" *ngIf="isLoading"></mat-spinner>
    </button>
    <button mat-flat-button color="primary" [disabled]="form.invalid || isLoading" (click)="saveEnergie()">
        <span *ngIf="!isLoading" [translate]="'global.actions.enregistrer'"></span>
        <mat-spinner class="m-5" diameter="28" *ngIf="isLoading"></mat-spinner>
    </button>
</div>